<template>
  <div>
    <el-card shadow="never" style="margin-top: 10px">
      <el-form :model="busData" label-width="150px" :rules="rules">

        <el-form-item label="授权方式：" required>
          <el-radio-group v-model="busData.lic_type" @change="calcTotalPrice" >
            <el-radio-button label="single" >单机版</el-radio-button>
            <el-radio-button label="net" >网络版</el-radio-button>
          </el-radio-group>

          <div class="secondLabel">付款方式：</div>
          <el-radio-group v-model="busData.pay_type" >
            <el-radio-button label="pay55" >55分期</el-radio-button>
            <el-radio-button label="pay64" >64分期</el-radio-button>
            <el-radio-button label="pay73" >73分期</el-radio-button>
            <el-radio-button label="pay82" >82分期</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="首年运维：" required>
          <el-radio-group v-model="busData.first_year_maintain" @change="calcTotalPrice" >
            <el-radio-button label="combine" >合并</el-radio-button>
            <el-radio-button label="separate" >拆开</el-radio-button>
          </el-radio-group>

          <div class="secondLabel" style="margin-left: 25px">运维年数：</div>
          <el-radio-group v-model="busData.maintain_years" @change="calcTotalPrice" >
            <el-radio-button label="1" >1年</el-radio-button>
            <el-radio-button label="3" >3年</el-radio-button>
            <el-radio-button label="5" >5年</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="最终使用单位：" >
          <el-input v-model="busData.use_company" placeholder="最终使用单位是本企业时无需填写" style="width: 530px" ></el-input>
        </el-form-item>

        <el-form-item label="选择联系人：" required>
          <el-select v-model="busData.contactId" class="form-item" placeholder="选择联系人" clearable="true"
                     filterable="true" style="margin-right:20px;width: 220px ">
            <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <FrameButton :button="addContactBtn" :parent-data="parentData"></FrameButton>
          <el-button style="margin-left: 20px" @click="addProductRow(1)">添加商品行</el-button>
        </el-form-item>
      </el-form>

      <el-row class="box">
        <el-col :span="8" style="text-align: left;padding-left: 10px">选择商品</el-col>
        <el-col :span="1">单位</el-col>
        <el-col :span="2">市场价</el-col>
        <el-col :span="1">税率%</el-col>
        <el-col :span="2">本体销售价</el-col>
        <el-col :span="2">本体折扣%</el-col>
        <el-col :span="2">运维标准价</el-col>
        <el-col :span="2">运维销售价</el-col>
        <el-col :span="2">运维折扣%</el-col>
        <el-col :span="2">数量</el-col>
      </el-row>

      <div style="width: 100%;height: 290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in busData.itemList" :key="item.product_ids" class="row" :gutter="25">
          <el-col :span="8">
            <el-cascader v-model="item.product_ids" :options="catalogWithProducts" style="width: 100%"
                         :show-all-levels="false" placeholder="选择商品"
                         :props="props" clearable filterable @change="onProductSelect(item)"/>
          </el-col>
          <el-col :span="1" class="tip">{{ item.unit }}</el-col>
          <el-col :span="2" class="tip">
            <span v-if="item.market_price > 0 && busData.first_year_maintain != 'combine'">{{ item.market_price }}</span>
            <span v-if="item.market_price > 0 && busData.first_year_maintain == 'combine'">{{ item.market_price_with_maintain }} (含首年运维)</span>
          </el-col>

          <el-col :span="1" class="tip">{{ item.tax_rate }}</el-col>
          <el-col :span="2">
            <el-input-number controls-position="right" v-model="item.sales_price" @change="changePrice(item, 'sales_price')" placeholder="本体价" style="width: 100%" />
          </el-col>
          <el-col :span="2">
            <el-input-number min="0" max="300" controls-position="right" v-model="item.discount_ratio" @change="changePrice(item, 'discount_ratio')" placeholder="本体折扣" style="width: 100%" />
          </el-col>

          <el-col :span="2" class="tip">{{ item.maintain_market_price }}</el-col>
          <el-col :span="2">
            <el-input-number controls-position="right" v-model="item.maintain_sales_price" @change="changePrice(item, 'maintain_sales_price')" placeholder="运维价" style="width: 100%" />
          </el-col>
          <el-col :span="2">
            <el-input-number min="0" max="300" controls-position="right" v-model="item.maintain_discount_ratio" @change="changePrice(item, 'maintain_discount_ratio')" placeholder="运维折扣" style="width: 100%" />
          </el-col>

          <el-col :span="2">
            <el-input-number v-model="item.cnt" @change="calcTotalPrice()" :min="0" :max="200" controls-position="right" placeholder="数量" style="width: 80%" />
            <div class="close" @click="removeOneMaterial(item.nanoid)">
              <el-icon>
                <ElIconClose></ElIconClose>
              </el-icon>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row style="margin-top: 15px">
        <el-col :span="24">
          <el-input type="textarea" class="quote-remark" v-model="busData.remark" placeholder="报价备注" style="width: 100%" :autosize="true"></el-input>
        </el-col>
      </el-row>

      <el-row style="margin-top: 15px">
        <el-col :span="9" class="tax-amount">
          <el-button type="primary" style="width: 100%;" @click="addQuote" :loading="loading">提交</el-button>
        </el-col>
        <el-col :span="3" :offset="3" class="tax-amount">
          <span v-if="busData.lic_type == 'net'">组网费：{{ busData.net_cost }}</span>
        </el-col>
        <el-col :span="3" class="tax-amount">
          <span>首年金额：{{ this.busData.first_year_amount }}</span>
        </el-col>
        <el-col :span="3" class="tax-amount">
          <span>次年金额：{{ this.busData.next_year_amount }}</span>
        </el-col>
        <el-col :span="3" class="tax-amount">
          <span>合同总额：{{ this.busData.total_amount }}</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 15px">
        <el-col :span="3" :offset="18" class="tax-amount">
          <span>报价毛利：{{ this.busData.gross_profit }}</span>
        </el-col>
        <el-col :span="3" class="tax-amount">
          <span>个人提成：{{ this.busData.personal_bonus }}</span>
        </el-col>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import {nanoid} from 'nanoid'

const messages = {
}

export default {
  name: "ChanceQuote",
  i18n: {messages},
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      addContactBtn: {
        "component": "button",
        "click": "jsOpenDialog",
        "label": "添加职员",
        "window": {
          "component": "frame/FrameForm",
          "type": "sales_chance_tab_contact_add",
          "title": "添加职员",
          "width": 600,
          "height": 600
        }
      },
      priceTips: false,
      dialogFormVisible: false,
      busData: {
        lic_type: 'single',
        pay_type: 'pay64',
        first_year_maintain: 'combine',
        maintain_years: 3,
        net_cost: 40000,
        customerSealed: false,
        fileGenerateType: 'system_generate',
        uploadFileIds: [],
        first_year_amount: 0,
        next_year_amount: 0,
        tax_amount: 0,
        total_amount: 0,
        personal_bonus: 0,
        gross_profit: 0,
        contactId: '',
        chanceId: '',
        remark: '',
        itemList: [],
        contractVariableList: [],
        quoteTemplateId: ''
      },
      imageUrl: '',
      contactList: [],
      productAll: [],
      catalogWithProducts: [],
      makeTypeList: [{value: "system_generate", label: "从模板生成"}, {value: "upload", label: "上传文件"}],
      uploadOptions: {component: 'file_upload', limit: 1, accept: ".pdf,.xlsx,.docx,.xls,.doc"},
      quoteList: [],
      quoteTemplateList: [],
      loading: false,
      rules: {
        contactId: [{required: true, message: '', trigger: 'blur'}],
        quoteTemplateId: [{required: true, message: '', trigger: 'blur'}],
      }
    }
  },
  provide() {
    return {
      $fn: {
        reloadContact: () => {
          this.getCompanyContactList();
        }
      }
    }
  },
  created() {
    this.addProductRow(6)
    this.getCompanyContactList()
    this.getCatalogWithProducts()
    this.getQuoteTemplateList()
    this.getQuoteList()
  },
  methods: {
    async getCatalogWithProducts() {
      this.catalogWithProducts = await this.$http('crmProductCatalogService.getCatalogWithProducts')
      //从目录树里面获取所有产品，不要再从后端读一次
      this.productAll = []
      this.readProducts(this.catalogWithProducts)
    },
    readProducts(catalogList) {
      if (!catalogList || catalogList.length == 0) {
        return;
      }

      for (var i = 0; i < catalogList.length; i++) {
        var busObject = catalogList[i]
        if (busObject.is_product == true) {

          //处理本体和运维价格
          busObject.market_price = this.getProductPrice(busObject, 'software')?.price || 0;
          busObject.tax_rate = this.getProductPrice(busObject, 'software')?.tax_rate || 13;
          busObject.maintain_market_price = this.getProductPrice(busObject, 'maintain')?.price || 0;
          busObject.market_price_with_maintain = this.getProductPrice(busObject, 'software_with_maintain')?.price || 0;

          this.productAll.push(busObject);
        } else {
          this.readProducts(busObject.children)
        }
      }
    },
    getProductPrice(product, authorizeType){
      if(product == null || authorizeType == null || product.price_list == null || product.price_list.length == 0){
        return null;
      }

      for (var i = 0; i < product.price_list.length; i++) {
        if (product.price_list[i].authorize_type == authorizeType) {
          return product.price_list[i];
        }
      }
      return null;
    },
    getProductById(productId) {
      for (var i = 0; i < this.productAll.length; i++) {
        if (this.productAll[i].id == productId) {
          return this.productAll[i];
        }
      }
      return null;
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()

    },

    clearPreData() {
      //清空表单数据
      this.busData.result = ''
      this.busData.remark = ''
      this.busData.itemList = []
      this.addProductRow(6);
      this.calcTotalPrice();
    },

    //获取联系人
    async getCompanyContactList() {
      let params = {chance_id: this.parentData.chance_id}
      this.contactList = await this.$http('crmChanceService.getCompanyContact', params)
    },
    //获取报价列表
    async getQuoteList() {
      let params = {chance_id: this.parentData.chance_id}
      this.quoteList = await this.$http('crmQuoteService.getChanceQuotes', params)
    },

    //获取报价明细
    async loadQuoteItems() {
      if (this.busData.quoteId == '') {
        return;
      }

      let params = {quote_id: this.busData.quoteId}
      let quoteData = await this.$http('crmQuoteService.getQuoteWithDetail', params)
      this.busData.itemList = quoteData.item_list || [];
      this.calcTotalPrice();
    },

    getQuoteLabel(item) {
      var amountFormat = this.formatMoney(item.total_amount);
      return item.quote_no + ' (' + amountFormat + ")";
    },
    changePrice(item, eventField) {
      if (!item.product_id) {
        this.$message.error("请先选择商品");
        return;
      }

      //销售价修改
      if('sales_price' == eventField){
        if (item.market_price == 0) {
          item.discount_ratio = 0
          return;
        }

        item.discount_ratio = parseInt(item.sales_price * 100 / item.market_price);
        if(this.busData.first_year_maintain == 'combine'){
          item.discount_ratio = parseInt(item.sales_price * 100 / item.market_price_with_maintain);
        }
      }

      //本体折扣
      if('discount_ratio' == eventField){
        item.sales_price = parseInt(item.market_price * item.discount_ratio / 100);
        if(this.busData.first_year_maintain == 'combine'){
          item.sales_price = parseInt(item.market_price_with_maintain * item.discount_ratio / 100);
        }
      }

      //运维价修改
      if('maintain_sales_price' == eventField){
        if (item.maintain_market_price == 0) {
          item.maintain_discount_ratio = 0
        }else{
          item.maintain_discount_ratio = parseInt(item.maintain_sales_price * 100 / item.maintain_market_price);
        }
      }

      //运维折扣
      if('maintain_discount_ratio' == eventField){
        item.maintain_sales_price = parseInt(item.maintain_market_price * item.maintain_discount_ratio / 100);
      }

      //重新计算总价
      this.calcTotalPrice();
    },
    //获取商品详情
    onProductSelect(item) {
      console.log("item.product_ids:")
      console.log(item.product_ids)
      if (!item.product_ids || item.product_ids.length == 0) {
        item.product_id = '';
        item.unit = '';
        item.market_price = 0;
        item.market_price_format = '';
        item.tax_rate = 0;
        item.sales_price = 0;
        item.discount_ratio = 0;
        item.cnt = 0;
        this.calcTotalPrice();
        return
      }

      var productId = item.product_ids[item.product_ids.length - 1]
      console.log("productId=" + productId)

      var product = this.getProductById(productId);
      if (!product) {
        return this.$message.error("未找到商品,id:" + productId);
      }

      item.product_id = product.id;
      item.unit = product.unit;
      item.market_price = product.market_price;
      item.market_price_with_maintain = product.market_price_with_maintain;

      item.maintain_market_price = product.maintain_market_price;
      item.market_price_format = this.formatMoney(item.market_price);
      item.tax_rate = product.tax_rate;

      this.calcTotalPrice();
    },
    //计算总价
    calcTotalPrice() {
      this.busData.total_amount = 0;
      this.busData.tax_amount = 0;
      this.busData.first_year_amount = 0;
      this.busData.next_year_amount = 0;
      this.busData.personal_bonus = 0;
      this.busData.gross_profit = 0;

      for (var i = 0; i < this.busData.itemList.length; i++) {
        var item = this.busData.itemList[i]

        if (item.product_id && item.sales_price && item.cnt) {
          var itemAmount = item.sales_price * item.cnt
          var maintainAmount = item.maintain_sales_price * item.cnt

          this.busData.first_year_amount += itemAmount;
          this.busData.next_year_amount += maintainAmount;
          this.busData.tax_amount += itemAmount * item.tax_rate / (100 + item.tax_rate);
        }
      }

      this.busData.total_amount = this.busData.first_year_amount + (this.busData.maintain_years - 1) * this.busData.next_year_amount;

      if(this.busData.lic_type == 'net'){
        this.busData.total_amount = this.busData.total_amount + this.busData.net_cost;
      }
    },
    //将数字转换成金额显示
    formatMoney(num) {
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },
    async getQuoteTemplateList() {
      this.quoteTemplateList = await this.$http('crmDsService.getQuoteTemplates')
    },
    addQuote() {
      if(this.busData.contactId == ''){
        return this.$message.error(`联系人未选择`);
      }

      var a = 0;
      for (let i = 0; i < this.busData.itemList.length; i++) {
        let obj = this.busData.itemList[i]
        if (obj.product_id) {

          if (!obj.market_price) {
            return this.$message.error(`第${i + 1}行标准价不能为空`);
          }

          if (!obj.tax_rate) {
            return this.$message.error(`第${i + 1}行税率不能为空`);
          }

          if (!obj.sales_price) {
            return this.$message.error(`第${i + 1}行销售价不能为空`);
          }

          if (!obj.cnt) {
            return this.$message.error(`第${i + 1}行数量不能为空`);
          }

          a++;
          obj.has_data = true;
        }
      }

      if (a == 0) {
        return this.$message.error("报价数据不能为空");
      }

      this.busData.chanceId = this.parentData.chance_id;
      this.loading = true;

      this.$http('crmQuoteService.makeQuote335New', this.busData).then(data => {
        this.loading = false;
        this.clearPreData();
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },
    addProductRow(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.busData.itemList.push({
          nanoid: nanoid(),
          productDetails: {}
        })
      }
    },
    removeOneMaterial(nanoid) {
      let index = this.busData.itemList.findIndex(item => item.nanoid === nanoid);
      this.busData.itemList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.secondLabel{
  width: 170px;
  text-align: right;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>